/**
 * @file index.ts
 * @description Индексный файл очередей системы управления задачами.
 * Экспортирует конфигурации для работы с очередями задач.
 * Определяет интерфейс IEntityData для описания структуры данных очередей
 * с полями для поиска, фильтрации и отображения в табличном виде.
 * Централизует настройки всех типов очередей в системе.
 * @author AI Assistant
 * @created 2025-09-04
 * @updated 2025-09-04
 * @dependencies []
 * @related-files [./task.tsx]
 */

import { IQueuePage } from '@src/types/page';
import * as task from './task';

const items: IQueuePage[] = [task];

export default items;
